import React from "react";
import { Badge } from "@shared/ui/badge";
import { Timer, Clock9, Clock } from "lucide-react";
import { useGetFieldForceAvailability } from "@features/wx/fieldForce/hooks";
import { useParams } from "react-router-dom";

interface AvailabilityTabProps {
  technicianId: string;
}

export const AvailabilityTab: React.FC<AvailabilityTabProps> = ({
  technicianId,
}) => {
  const { id } = useParams();
  const { data: availabilityData, refetch } = useGetFieldForceAvailability(id);

  const schedule = availabilityData?.availability?.availabilitySchedule || [];

  return (
    <div className="">
      <h3 className="card-heading-text mb-4 flex items-center">
        <Timer className="mr-2 h-5 w-5 text-blue-500" />
        Weekly Schedule
      </h3>

      <div className="space-y-4">
        {schedule.map((daySchedule) => {
          return (
            <div key={daySchedule.day} className="border p-4 rounded-lg">
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-medium">{daySchedule.day}</h4>

                <Badge
                  className={
                    daySchedule?.isWeeklyOff
                      ? "bg-red-100 text-red-800 border border-red-200 hover:bg-red-100"
                      : "bg-green-100 text-green-800 border border-green-200 hover:bg-green-100"
                  }
                >
                  {daySchedule?.isWeeklyOff ? "Unavailable" : "Available"}
                </Badge>
              </div>

              {daySchedule?.isWeeklyOff ? (
                <p className="text-sm text-muted-foreground mt-2">
                  Not scheduled to work on this day
                </p>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">
                      Start Time
                    </p>
                    <p className="font-medium flex items-center">
                      <Clock9 size={14} className="text-blue-500 mr-1" />
                      {daySchedule.startTime || "N/A"}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-muted-foreground mb-1">
                      End Time
                    </p>
                    <p className="font-medium flex items-center">
                      <Clock size={14} className="text-blue-500 mr-1" />
                      {daySchedule.endTime || "N/A"}
                    </p>
                  </div>

                  {daySchedule?.isOvertime && (
                    <div className="col-span-2 mt-2">
                      <Badge className="bg-amber-100 text-amber-800 border border-amber-200 hover:bg-amber-100">
                        Available for overtime
                      </Badge>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
